<template>
    <div class="w-full text-black">
        <div class="flex items-center justify-between pb-[18px] border-b">
            <div>
                <h2 class="text-[20px] font-light">Information Banque</h2>
                <p class="text-[13px] font-extralight mt-2">Mettre à jour les détails de votre compte</p>
            </div>
            <div class="flex items-center gap-x-[6px] font-light">
                <button class="h-[40px] border rounded-xl px-6">Annuler</button>
                <button v-on:click="updateEmploye" class="h-[40px] px-6 border border-[#3c41e9] bg-[#3c41e9] text-white rounded-xl">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                    <span v-if="!asSend">Sauvegarder</span>
                </button>
            </div>
        </div>
        <div class="flex items-start">
            <label for="photo" class="font-light w-[200px] pt-[18px]">Rib</label>
            <div class="grow py-[18px] border-b">
                <input type="text" v-model="form.rib" placeholder="Rib" class="border font-extralight rounded-xl p-6 w-full h-[40px]">
            </div>
        </div>
        <div class="py-[18px] flex items-start">
            <label for="photo" class="font-light w-[200px]">Code SWIFT</label>
            <div class="grow">
                <input type="text" v-model="form.swift" placeholder="SWIFT" class="border font-extralight rounded-xl p-6 w-full h-[40px]">
            </div>
        </div>
        <div class="flex items-start">
            <label for="photo" class="font-light w-[200px] pt-[18px]">Banque</label>
            <div class="grow py-[18px] border-t border-b">
                <input type="text" v-model="form.bank" placeholder="Banque" class="border font-extralight rounded-xl p-6 w-full h-[40px]">
            </div>
        </div>
        <div class="py-[18px] flex items-start">
            <label for="photo" class="font-light w-[200px]">Numéro Cnps</label>
            <div class="grow">
                <input type="text" v-model="form.n_cnps" placeholder="Numéro Cnps" class="border font-extralight rounded-xl p-6 w-full h-[40px]">
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import Swal from "sweetalert2";
import API from "@/service/API";
export default {
    name: "UserBank",
    components:{
        Loader2
    },
    props:["user"],
    mounted(){
        const {rib,swift,bank,n_cnps} = this.user;
        this.form = {rib,swift,bank,n_cnps};
    },
    data(){
        return {
            form:{},
            asSend:false
        }
    },
    methods:{
        updateEmploye(){
            const userId = localStorage.getItem("userId");
            this.asSend = true;
            API.post('updateEmployee/' + userId,{...this.form})
            .then((res)=>{
                if(res.data.status){
                //   this.getUsersInfo(this.id);
                  Swal.fire('Succès!!!!',"Infomation mis à jour",'succes')
                }
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{this.asSend = false;})
        },
    }
}
</script>